/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { LOCALISATION_BASE_URL, LOCALISATION_VERSION } from '@myprofile-ui/myprofile-localisation-api'
import { PidxUiComponentsModule } from '@myprofile-ui/pidx-ui-components'
import { PidxUtilsModule } from '@myprofile-ui/pidx-utils'
import { TranslatePipe } from '@ngx-translate/core'
import { MyProfileBirthdayDisplayComponent } from './components/myprofile-birthday-display/myprofile-birthday-display.component'
import { MyProfileBirthdayEditformComponent } from './components/myprofile-birthday-editform/myprofile-birthday-editform.component'
import { MyProfileBirthdayWidgetComponent } from './myprofile-birthday-widget.component'
import { RESTRICT_GLOBAL_UI_CHANGES } from '../../../pidx-utils/src/lib/helpers/restrictGlobalUIChanges.injectionToken'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { BASE_PATH } from '@myprofile-ui/pidx-utils'

@NgModule({
  declarations: [MyProfileBirthdayWidgetComponent, MyProfileBirthdayEditformComponent, MyProfileBirthdayDisplayComponent],
  exports: [MyProfileBirthdayWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, ReactiveFormsModule, PidxUtilsModule, PidxUiComponentsModule, TranslatePipe, PorscheDesignSystemModule],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class MyProfileBirthdayWidgetModule {
  static forRoot(
    basePath: string,
    localisationBaseUrl: string,
    isProduction: boolean,
    restrictGlobalUIChanges: boolean,
  ): ModuleWithProviders<MyProfileBirthdayWidgetModule> {
    return {
      ngModule: MyProfileBirthdayWidgetModule,
      providers: [
        { provide: BASE_PATH, useValue: basePath },
        { provide: LOCALISATION_BASE_URL, useValue: localisationBaseUrl },
        { provide: LOCALISATION_VERSION, useValue: isProduction ? 'RELEASE' : 'LATEST' },
        { provide: RESTRICT_GLOBAL_UI_CHANGES, useValue: restrictGlobalUIChanges },
      ],
    }
  }
}
